module.exports = __webpack_public_path__ + "static/media/SieuVoucherMyVNPT_1200x600px.02d9e3bb.png";